export default {
  title: "Shipping Companies",
  subtitle: "Manage shipping companies and logistics",
  
  addNew: "Add New Shipping Company",
  createShippingCompany: "Create Shipping Company",
  editShippingCompany: "Edit Shipping Company",
  deleteShippingCompany: "Delete Shipping Company",
  
  fields: {
    name: "Company Name",
    code: "Company Code",
    contactPerson: "Contact Person",
    email: "Email",
    phone: "Phone",
    address: "Address",
    website: "Website",
    trackingUrl: "Tracking URL",
    isActive: "Active",
    shippingRates: "Shipping Rates",
    deliveryTime: "Delivery Time",
    coverage: "Coverage Area",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At",
    maxWeight: "Max Weight",
    maxDimension: "Max Dimension",
    fuelSurchargeRate: "Fuel Surcharge Rate",
    complexSurchargeRate: "Complex Surcharge Rate",
    dwDivisor: "DW Divisor",
    insuranceRate: "Insurance Rate",
    dgFees: "DG Fees",
    pricingTable: "Pricing Table"
  },
  
  placeholders: {
    name: "Enter company name",
    code: "Enter company code",
    contactPerson: "Enter contact person name",
    email: "Enter email address",
    phone: "Enter phone number",
    address: "Enter company address",
    website: "Enter website URL",
    trackingUrl: "Enter tracking URL template",
    deliveryTime: "Enter delivery time (e.g., 2-3 days)",
    coverage: "Enter coverage area",
    maxWeight: "Enter maximum weight",
    maxDimension: "Enter maximum dimension",
    fuelSurchargeRate: "Enter fuel surcharge rate",
    complexSurchargeRate: "Enter complex surcharge rate",
    dwDivisor: "Enter DW divisor",
    insuranceRate: "Enter insurance rate",
    dgFees: "Enter DG fees"
  },
  
  messages: {
    createSuccess: "Shipping company created successfully",
    createError: "Failed to create shipping company",
    updateSuccess: "Shipping company updated successfully",
    updateError: "Failed to update shipping company",
    deleteSuccess: "Shipping company deleted successfully",
    deleteError: "Failed to delete shipping company",
    deleteConfirm: "Are you sure you want to delete this shipping company?",
    noShippingCompanies: "No shipping companies found",
    loadingShippingCompanies: "Loading shipping companies...",
    fetchError: "Failed to fetch shipping companies",
    templateDownloadSuccess: "Template downloaded successfully",
    templateDownloadError: "Failed to download template",
    importSuccess: "Successfully imported {{count}} price entries",
    importReplaceSuccess: "Successfully replaced all prices with {{count}} imported entries",
    importError: "Failed to import prices from Excel",
    importEmpty: "No valid price entries found in the file",
    invalidFileType: "Please upload a valid Excel file (.xlsx or .xls)"
  },
  
  validation: {
    nameRequired: "Company name is required",
    codeRequired: "Company code is required",
    emailFormat: "Please enter a valid email address",
    phoneFormat: "Please enter a valid phone number",
    websiteFormat: "Please enter a valid website URL",
    trackingUrlFormat: "Please enter a valid tracking URL",
    maxWeightRequired: "Maximum weight is required",
    maxDimensionRequired: "Maximum dimension is required",
    dwDivisorRequired: "DW divisor is required",
    allFieldsRequired: "All fields must be filled",
    fillAllFields: "Please fill in all required fields"
  },
  
  table: {
    name: "Name",
    code: "Code",
    contactPerson: "Contact",
    phone: "Phone",
    email: "Email",
    deliveryTime: "Delivery Time",
    coverage: "Coverage",
    status: "Status",
    actions: "Actions",
    maxWeight: "Max Weight",
    normalFast: "Normal Fast",
    normalEconomy: "Normal Economy",
    dangerousFast: "Dangerous Fast",
    dangerousEconomy: "Dangerous Economy",
    sourceCountry: "Source Country",
    destinationCountry: "Destination Country"
  },
  
  statusOptions: {
    active: "Active",
    inactive: "Inactive",
    suspended: "Suspended"
  },
  
  breadcrumbs: {
    shippingCompanies: "Shipping Companies",
    create: "Create Shipping Company",
    edit: "Edit Shipping Company",
    view: "View Shipping Company"
  },

  buttons: {
    submit: "Submit",
    update: "Update",
    submitting: "Submitting...",
    updating: "Updating...",
    backToIndex: "Back to Index",
    addPriceEntry: "Add Price Entry",
    downloadTemplate: "Download Template",
    importFromExcel: "Import from Excel",
    importing: "Importing..."
  }
};
